import { useEffect, useState } from 'react'
import { useAppContext } from 'Contexts'
import { Fa } from '@eltoro-ui/components'

export const GetName = ({ userId }: { userId: string }) => {
  const { userServiceApi } = useAppContext()
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (
      (process.env.REACT_APP_ENV === 'development' ||
        /dev/.test(window.location.hostname)) &&
      userId === 'f89eeedf-2e99-420c-bf77-67bbf215519d'
    ) {
      setName('El Toro Ad Operations')
      setLoading(false)
      return
    }
    if (
      process.env.REACT_APP_ENV === 'production' &&
      userId === 'eb64d640-8e7b-48f4-b868-fefd59524a27'
    ) {
      setName('El Toro Ad Operations')
      setLoading(false)
      return
    }
    const _getName = async () => {
      if (!userId || !userServiceApi) return ''

      return await userServiceApi
        .advertisingPlatformServiceGetUser(userId)
        .then((res) => {
          setName(`${res.firstName} ${res.lastName}`)
          setLoading(false)
        })
    }

    _getName()
  }, [])

  if (loading) {
    return <Fa icon="spinner" animate="spin" size={1} />
  }

  return <>{name}</>
}
